import React from 'react'
import propTypes from 'prop-types'
import { Radar } from 'react-chartjs-2'

import { buildChartJsOptionsProp } from './options'

import { getChartHeight } from '@utils/heights'

export const RadarChart = ({ className, height, data, options }) => {

  return (
    <div className={className} style={{ height: getChartHeight(height) }}>
      <Radar
        options={buildChartJsOptionsProp(options)}
        data={data}
      />
    </div>
  )
}

RadarChart.propTypes = {
  labels: propTypes.array.isRequired,
  data: propTypes.array.isRequired,
  className: propTypes.string,
  height: propTypes.string,
  options: propTypes.object
}

RadarChart.defaultProps = {
  options: {},
  height: '',
  className: ''
}
